module.exports = __webpack_public_path__ + "static/media/17-konkurranse.400bb526.mp3";